module.exports = __webpack_public_path__ + "static/img/all-fabric-icon.e50e2324.png";